export const valueOrZero = value => value || 0;
